import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/Button';
import LandingContainer from '../LandingContainer';
import { ArrowRight, Check } from 'lucide-react';

const OUTCOMES = [
  'Every field stored in your inbox',
  'An email for each submission',
  'Files kept with the submission',
];

const HeroSection = () => {
  return (
    <section className="relative w-full min-w-0 overflow-hidden bg-white pt-8 pb-12 sm:pt-14 sm:pb-20">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-80 bg-[radial-gradient(ellipse_at_top,rgba(74,144,226,0.18),transparent_68%)]" />
      <LandingContainer>
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="min-w-0 text-center lg:text-left">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary-700">
              HTML form backend
            </p>
            <h1 className="mt-3 font-heading text-[1.85rem] font-bold leading-[1.12] tracking-tight text-charcoal-900 xs:text-4xl sm:text-5xl lg:text-[3.25rem]">
              Form submissions, without a backend.
            </h1>
            <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-charcoal-600 sm:text-lg lg:mx-0">
              Paste one URL into the HTML form you already have. FormCare stores each submission and emails you every field.
            </p>
            <div className="mt-7 flex flex-col items-center gap-3 sm:mt-8 lg:items-start">
              <Button asChild size="lg" className="min-h-12 w-full sm:w-auto">
                <Link to="/register">
                  Start free
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
              <p className="text-sm leading-5 text-charcoal-500">
                No credit card. 150 submissions a month. 10 forms.
              </p>
            </div>
          </div>

          <div className="min-w-0">
            <div className="rounded-3xl border border-neutral-200 bg-white p-3 shadow-[0_24px_60px_-32px_rgba(44,62,80,0.45)] sm:p-4">
              <p className="px-2 pb-2 text-xs font-semibold uppercase tracking-[0.14em] text-charcoal-500">
                The only change in your HTML
              </p>
              <pre className="overflow-x-auto rounded-2xl bg-charcoal-900 p-4 text-left text-[13px] leading-6 text-primary-100 sm:p-5 sm:text-sm">
                <code className="block whitespace-pre-wrap">
                  {'<form method="POST"\n  action="'}
                  <span className="text-success-300">{'https://formcare.io/'}</span>
                  <wbr />
                  <span className="text-success-300">{'api/submit/contact'}</span>
                  {'">'}
                </code>
              </pre>
              <ul className="mt-3 space-y-2 px-1 pb-1">
                {OUTCOMES.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm leading-6 text-charcoal-700">
                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success-50 text-success-700">
                      <Check className="h-3.5 w-3.5" aria-hidden />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </LandingContainer>
    </section>
  );
};

export default HeroSection;
